import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlUlComponent } from './pl-ul.component';
import { ButtonModule } from '@app/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { SafeHtmlPipeModule } from '@shared/pipes/safeHtml/safeHtml.pipe.module';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    PlIconModule,
    MatExpansionModule,
    SafeHtmlPipeModule,
    PlSlicePipeModule,
  ],
  declarations: [PlUlComponent],
  exports: [PlUlComponent],
})
export class PlUlModule {}
